import { mapActions, mapGetters } from 'vuex'

import { Colors } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'Version',

  data() {
    return {
      interval: undefined
    }
  },

  computed: {
    ...mapGetters({
      currentVersion: 'version/current',
      hasNewVersion: 'version/hasNewVersion'
    })
  },

  created() {
    this.setVersion()
    this.interval = setInterval(() => this.setVersion(), 60 * 1000)
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = undefined
    }
  },

  methods: {
    ...mapActions({ setVersion: 'version/set' }),

    copy() {
      navigator.clipboard.writeText('v' + this.currentVersion)
      this.addSnackbar({
        text: this.getTranslate('version.notifications.copied'),
        type: Colors.success
      })
    }
  },

  render
}
